import {Alert, Badge, Card, Col, Container, Row, Table} from "react-bootstrap";
import React, {FC, useEffect, useRef, useState} from "react";
import FullCalendar from "@fullcalendar/react";
import timeGridWeek from '@fullcalendar/timegrid'
import bootstrap5Plugin from '@fullcalendar/bootstrap5'
import listPlugin from '@fullcalendar/list';
import axios from "axios";
import {useAuth} from "../../../context/AuthProvider";
import momentPlugin from "@fullcalendar/moment";
import momentTimezonePlugin from "@fullcalendar/moment-timezone";
import {useTranslation} from "react-i18next";
import moment from "moment";

type BookingCalendarComponentProps = Record<string, unknown>;

const BookingCalendarComponent: FC<BookingCalendarComponentProps> = () => {
    const auth = useAuth()
    const {t, i18n} = useTranslation("admin")

    const events = [
        {title: 'Meeting', start: new Date("2025-01-06 10:00:00"), end: new Date("2025-01-06 11:00:00")}
    ]
    const [bookings, setBookings] = useState<Array<any>>([])
    const [currentCalendarDate, setCurrentCalendarDate] = useState<Number>(Date.now())
    const [selectedTimeSlot, setSelectedTimeSlot] = useState<any>(null)
    const [selectedTimeSlotDetail, setSelectedTimeSlotDetail] = useState<any>(null)

    const calendarRef = useRef<FullCalendar>(null)

    useEffect(() => {
        axios.get("/api/booking/all/" + currentCalendarDate, auth.axiosAuthHeader()).then(res => {
            setBookings(res.data)
        })
    }, [currentCalendarDate]);

    useEffect(() => {
        if (selectedTimeSlot) {
            axios.get("/api/booking/detail/" + selectedTimeSlot._id, auth.axiosAuthHeader()).then(res => {
                setSelectedTimeSlotDetail(res.data)
            })
        }
    }, [selectedTimeSlot, setSelectedTimeSlot]);

    function renderEventContent(eventInfo: any) {
        return (
            <>
                <span>
                    {eventInfo.timeText}

                    {eventInfo.event.extendedProps.load < 3 ?
                            <Badge bg="primary">{eventInfo.event.extendedProps.load}/10</Badge> :
                            eventInfo.event.extendedProps.load < 7 ?
                                <Badge bg="warning">{eventInfo.event.extendedProps.load}/10</Badge> :
                                eventInfo.event.extendedProps.load >= 7 ?
                                    <Badge bg="danger">{eventInfo.event.extendedProps.load}/10</Badge> :
                                    null
                    }
                    { eventInfo.event.extendedProps.isDemo? <Badge bg="secondary">DEMO</Badge> : null }
                </span>
            </>
        )
    }

    const changeDate = (d: any) => {
        setCurrentCalendarDate(d.start.getTime())
    };

    const handleEventClick = (event: any) => {
        calendarRef!.current!.getApi().getEvents().forEach((ev: any) => {
            ev.setProp("classNames", "")
        })
        event.event.setProp("classNames", "bg-success")
        setSelectedTimeSlot(event.event.extendedProps)
    };

    const renderEventContentList = (eventInfo: any) => {

    }
    return (<div className="component">
        <Container fluid>
            <Row>
                <Col>
                    <Card>
                        <Card.Header><h3><i className="bi bi-calendar-range"></i> {t("bookingCalendar.title")}</h3></Card.Header>
                        <Card.Body>
                                {selectedTimeSlot && selectedTimeSlotDetail ? <><h3>{selectedTimeSlotDetail.bookingSlot._id}</h3> {moment(selectedTimeSlot.createdAt).format()}<Table striped bordered hover>
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>{t("bookingCalendar.columns.name")}</th>
                                        <th>ObjectId</th>
                                        <th>ESI</th>
                                        <th>Mail</th>
                                        <th>{t("bookingCalendar.columns.exam")}</th>
                                        <th>{t("bookingCalendar.columns.details")}</th>
                                        <th>{t("bookingCalendar.columns.assignments")}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {selectedTimeSlotDetail.bookings.map((booking: any, idx: number) => (
                                        <tr>
                                            <td>{(idx + 1)}</td>
                                            <td>{booking._id}</td>
                                            <td>{booking.user.given_name} {booking.user.family_name}</td>
                                            <td><small style={{fontSize: "xx-small"}}>{booking.user.esi}</small></td>
                                            <td><small style={{fontSize: "xx-small"}}>{booking.user.email}</small></td>
                                            <td>{i18n.language === "en" ? booking.exam.name_en || booking.exam.name_de : booking.exam.name_de}</td>
                                            <td>
                                                <ul>
                                                    <li>{booking.keyboardLayout}</li>
                                                    <li>{t(booking.mouseLeft ? "bookingCalendar.mouseLeft" : "bookingCalendar.mouseRight")}</li>
                                                    <li>{booking.user.lang}</li>
                                                    <li><a href={"/api/site/getIdentityScan/" + booking._id} target="_blank" rel="noreferrer">{t("bookingCalendar.showId")}</a></li>
                                                    <li><a href={"/api/site/getFrontalCapture/" + booking._id} target="_blank" rel="noreferrer">{t("bookingCalendar.showFrontal")}</a></li>
                                                </ul>
                                            </td>
                                            <td>
                                                <ul>
                                                    <li>PIN: {booking.pinCode}</li>
                                                    <li>{t("bookingCalendar.seat")}: {booking.seat.name}</li>
                                                    <li>{t("bookingCalendar.locker")}: {booking.locker ? booking.locker : t("bookingCalendar.notSet")}</li>
                                                </ul>
                                            </td>

                                        </tr>
                                    ))
                                    }
                                    </tbody>
                                </Table></> : null}
                            <FullCalendar
                                plugins={[momentTimezonePlugin, momentPlugin, bootstrap5Plugin, timeGridWeek, listPlugin]}
                                initialView='timeGridWeek'
                                headerToolbar={{
                                    left: 'prev,next today',
                                    center: 'title',
                                    right: 'timeGridWeek,listMonth'
                                }}
                                themeSystem='bootstrap5'
                                weekends={false}
                                events={bookings.map((e: any) => {
                                    e.start = e.entryAt
                                    e.end = e.leaveUntil
                                    e.extendedProps = e
                                    e.d = e.duration
                                    e.demo = e.isDemo
                                    return e
                                })}
                                timeZone="Europe/Berlin"
                                ref={calendarRef}
                                eventClick={handleEventClick}
                                slotLabelFormat="HH:mm"
                                eventTimeFormat="HH:mm"
                                titleFormat='MMMM D, YYYY' // you can now use moment format strings!
                                slotMinTime="06:00"
                                slotMaxTime="22:00"
                                allDaySlot={false}
                                datesSet={(d: any) => changeDate(d)}
                                eventContent={renderEventContent}
                                listDayFormat="dddd, MMMM D, YYYY"
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </div>)
}

export default BookingCalendarComponent
